import { c as _c } from "react/compiler-runtime";
import { useToast } from '@onefootprint/ui';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import PhotoCapture from '../../../components/photo-capture';
import type { CameraErrorCause, ReceivedImagePayload } from '../../../types';
import { useNonIdDocMachine } from '../../components/machine-provider';
import useDocName from '../../hooks/use-doc-name';
const OUTLINE_HEIGHT_RATIO = 0.9;
const OUTLINE_WIDTH_RATIO = 0.9;
const MobileImageCapture = () => {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.non-id-doc.pages.mobile-image-capture"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const [state, send] = useNonIdDocMachine();
  const {
    hasBadConnectivity,
    requirement,
    allowPdf
  } = state.context;
  const {
    toast
  } = useToast();
  const docName = useDocName(requirement.config);
  let t1;
  if ($[1] !== send) {
    t1 = payload => send({
      type: "receivedDocument",
      payload
    });
    $[1] = send;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onComplete = t1;
  let t2;
  if ($[3] !== send) {
    t2 = () => {
      send({
        type: "navigatedToPrev"
      });
    };
    $[3] = send;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClickBack = t2;
  let t3;
  if ($[5] !== send) {
    t3 = cause => {
      send({
        type: "cameraErrored",
        payload: {
          cause
        }
      });
    };
    $[5] = send;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCameraError = t3;
  let t4;
  if ($[7] !== send) {
    t4 = () => {
      send({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      });
    };
    $[7] = send;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleCameraAccessDenied = t4;
  let t5;
  if ($[9] !== send || $[10] !== t || $[11] !== toast) {
    t5 = () => {
      toast({
        title: t(_temp),
        description: t(_temp2),
        variant: "error"
      });
      send({
        type: "cameraStuck"
      });
    };
    $[9] = send;
    $[10] = t;
    $[11] = toast;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleCameraStuck = t5;
  let t6;
  if ($[13] !== docName) {
    t6 = upperFirst(docName);
    $[13] = docName;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== docName) {
    t7 = upperFirst(docName);
    $[15] = docName;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = {
      camera: t6,
      preview: t7
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== allowPdf || $[21] !== docName || $[22] !== handleCameraAccessDenied || $[23] !== handleCameraError || $[24] !== handleCameraStuck || $[25] !== handleClickBack || $[26] !== hasBadConnectivity || $[27] !== onComplete || $[28] !== requirement || $[29] !== t8) {
    t9 = <PhotoCapture autocaptureKind="nonIdDoc" cameraKind="back" deviceKind="mobile" allowPdf={allowPdf} docName={docName} requirement={requirement} hasBadConnectivity={hasBadConnectivity} onCameraErrored={handleCameraError} onCameraAccessDenied={handleCameraAccessDenied} onCameraStuck={handleCameraStuck} onComplete={onComplete} onBack={handleClickBack} outlineHeightRatio={OUTLINE_HEIGHT_RATIO} outlineWidthRatio={OUTLINE_WIDTH_RATIO} title={t8} />;
    $[20] = allowPdf;
    $[21] = docName;
    $[22] = handleCameraAccessDenied;
    $[23] = handleCameraError;
    $[24] = handleCameraStuck;
    $[25] = handleClickBack;
    $[26] = hasBadConnectivity;
    $[27] = onComplete;
    $[28] = requirement;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export default MobileImageCapture;
function _temp($) {
  return $["camera-stuck"].title;
}
function _temp2($_0) {
  return $_0["camera-stuck"].description;
}